export default __webpack_public_path__ + "static/media/dealership@2x.e1247f23.svg";